module.exports = __webpack_public_path__ + "static/media/28.ac09a590.png";